import { render, staticRenderFns } from "./SingleProduct.vue?vue&type=template&id=7537aba8"
import script from "./SingleProduct.vue?vue&type=script&lang=js"
export * from "./SingleProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports